export enum OperationType {
  SURGICAL = 'SURGICAL',
  NONSURGICAL = 'NONSURGICAL',
  UNKNOWN = 'UNKNOWN',
}
